"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListHeaderView = void 0;
var React = require("react");
var ListHeaderView = function (props) { return (React.createElement("div", { className: "cf" },
    React.createElement("div", { className: "fl w-100 mb2" },
        React.createElement("div", { className: "fl mb3 w-60-ns w-50" },
            React.createElement("div", { className: "f3-ns f4 fw3 flex" },
                React.createElement("span", { className: "db dib w-100 w-30-ns w-auto-ns" }, props.title),
                React.createElement("span", { className: props.showCountInMobileView
                        ? 'black-70 f6 pl2 pt2 dib'
                        : 'black-70 f6 pl2 pt2 dn dib-ns' },
                    "(Showing",
                    React.createElement("span", { className: "fw5 i mh2" }, props.showing),
                    "of",
                    React.createElement("span", { className: "fw5 i mh2" }, props.queryTotal),
                    "results)"))),
        props.actionButton && (React.createElement("div", { className: "fl w-40-ns w-50" },
            React.createElement("div", { className: "fr" }, props.actionButton)))))); };
exports.ListHeaderView = ListHeaderView;
//# sourceMappingURL=Header.js.map